import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import DeleteUgcForm from 'app/components/bibs/shared/ugc/DeleteUgcForm';
import ModalContainer from 'app/components/shared/Modal/ModalContainer';

export default function DeleteSummaryModal({
  summaryId,
  catalogBib,
  summariesActions,
  handleSuccess,
  modalActions,
  summariesTransactions
}) {
  function handleClose() {
    modalActions.closeModal(`delete-summary-${summaryId}`);
  }

  return (
    <ModalContainer
      className="cp-delete-summary-modal"
      modalKey={`delete-summary-${summaryId}`}
      size="small"
      handleClose={handleClose}
    >
      <DeleteUgcForm
        ugcType="summary"
        id={summaryId}
        catalogBib={catalogBib}
        removeUgcAction={summariesActions.removeSummary}
        transactions={summariesTransactions}
        handleClose={handleClose}
        handleSuccess={handleSuccess}
      />
    </ModalContainer>
  );
}

DeleteSummaryModal.propTypes = {
  summaryId: PropTypes.number.isRequired,
  catalogBib: catalogBibShape.isRequired,
  handleSuccess: PropTypes.func,
  summariesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  summariesTransactions: ImmutablePropTypes.map.isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired
};
